import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TarefasSistemaService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'teste/PEAC';
  }

  public obterDataSistema(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/data-sistema/ISO`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public alterarDataSistema(data: string): Observable<any> {
    const options: any = blockUi();
    options.responseType = "text";
    return this.http.get(`${this.BASE_URL}/data-sistema/alterar/${data}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public obterAmbienteExecucao(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/data-sistema/ISO`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
}
